
export default {
  props: {
    openingHours: {
      type: Array,
      required: true,
    },
  },
};
